import * as LucideIcons from 'lucide-react';
import { ParticipantSearchBar } from './ParticipantSearchBar';

interface ParticipantToolbarProps {
  onSearchChange: (query: string) => void;
  onAddParticipant: () => void;
}

export const ParticipantToolbar: React.FC<ParticipantToolbarProps> = ({
  onSearchChange,
  onAddParticipant,
}) => {
  return (
    <div className="flex items-center gap-3 mb-6">
      <ParticipantSearchBar 
        onSearchChange={onSearchChange}
      />
      <button
        onClick={onAddParticipant}
        className="inline-flex items-center justify-center gap-2 w-[38px] h-[38px] md:w-auto md:h-auto md:px-3 md:py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-sm hover:bg-gray-50 whitespace-nowrap"
        data-pp-at-target="add-participant-button"
      >
        <LucideIcons.UserPlus size={16} />
        <span className="hidden md:inline">Add Participant</span>
      </button>
    </div>
  );
};
